var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.2,52c-0.4-7.2-1.4-10-2.2-11.1c-0.9-1.1-1.3-2.5-1.5-4c-1-10.2-2.8-19.6-3.9-24.5C77.2,10.4,75.4,9,73.2,9   C51.4,9.3,38,12.1,33.8,13.1c-0.9,0.2-1.8,0.8-2.4,1.5c-10.6,12.8-15.5,24-15.5,24c-3,9.4-1.3,18.2-0.1,22.4   c0.4,1.5,1.4,2.8,2.8,3.7c10.1,6.2,14.7,15.9,16.6,21.5c0.9,2.7,3.4,4.5,6.2,4.5h43C87.3,83.7,85.2,52,85.2,52z M42,49.8   c0,2-1.6,3.6-3.6,3.6h-6.9c-2,0-3.6-1.6-3.6-3.6l0,0c0-2,1.6-3.6,3.6-3.6h6.9C40.3,46.2,42,47.8,42,49.8L42,49.8z M74.2,40.2   l-42.5-1.4c-1.3,0-2.3-1.1-2.3-2.4V31c0-2,0.5-3.9,1.6-5.5l5.4-8.9c0.3-0.5,0.9-0.9,1.5-1.1c3.9-0.9,19.1-4,33.9-2.5   c1.1,0.1,2,1,2.1,2.1l2.7,22.6C76.9,39,75.7,40.3,74.2,40.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDoor);
export default __webpack_public_path__ + "static/media/car_door.99192a89f64cf8449d0af35621b28535.svg";
export { ForwardRef as ReactComponent };